"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_select_1 = __importDefault(require("react-select"));
const CommonSelect = (props) => {
    var _a;
    const value = props.value !== undefined && props.value !== null
        ? (_a = props.options) === null || _a === void 0 ? void 0 : _a.find((o) => o.value === props.value)
        : null;
    return ((0, jsx_runtime_1.jsx)(react_select_1.default, Object.assign({ noOptionsMessage: () => "Sem opções", isClearable: true }, props, { value: value }), void 0));
};
exports.CommonSelect = CommonSelect;
